import {createYtScript} from '../helpers/ElementHelper';
import Swiper, {Pagination, Navigation} from 'swiper';
import {videoCarousel as config} from '../configs/Swiper';
import {switchActive} from '../helpers/ActionHelper';

export class VideoCarouselComponent {
  container;

  containerDesktop;

  containerMobile;

  swiper;

  swiperMobile;

  constructor() {
    this.container = document.querySelector('.c-video-carousel-wrapper');
    this.containerDesktop = document.querySelector('.c-video-carousel.desktop');
    this.containerMobile = document.querySelector('.c-video-carousel.mobile');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    createYtScript();

    this.addEventListeners();

    this.initSwiper();
  }

  initSwiper() {
    Swiper.use([Pagination, Navigation]);

    const containerDesktop = this.containerDesktop.querySelector('.js-video-carousel');
    this.swiper = new Swiper(containerDesktop, config);
    this.swiper.on('activeIndexChange', (swiper) => this.activeIndexChangeHandler(swiper));

    const containerMobile = this.containerMobile.querySelector('.js-video-carousel');
    this.swiperMobile = new Swiper(containerMobile, config);
    this.swiperMobile.on('activeIndexChange', (swiper) => this.mobileActiveIndexChangeHandler(swiper));
  }

  addEventListeners() {
    const slideSwitchers = [...this.containerDesktop.querySelectorAll('.js-switch-slide')];
    slideSwitchers.forEach((slideSwitcher) => {
      slideSwitcher.addEventListener('click', (e) => this.slideSwitcherClickHandler(e));
    });

    const desktopPlayControls = [...this.containerDesktop.querySelectorAll('.js-play')];
    desktopPlayControls.forEach((desktopPlayControl) => {
      desktopPlayControl.addEventListener('click', (e) => this.desktopPlayControlClickHandler(e));
    });

    const mobilePlayControls = [...this.containerMobile.querySelectorAll('.js-play')];
    mobilePlayControls.forEach((mobilePlayControl) => {
      mobilePlayControl.addEventListener('click', (e) => this.mobilePlayControlClickHandler(e));
    });
  }

  slideSwitcherClickHandler(e) {
    const target = e.target.closest('.js-switch-slide');
    if (!target || target.classList.contains('active')) {
      return;
    }

    switchActive(target);

    const index = [...target.parentNode.children].indexOf(target);
    this.swiper.slideTo(index);
  }

  desktopPlayControlClickHandler(e) {
    const target = e.target.closest('.preview');
    if (!target) {
      return;
    }

    const container = target.closest('.video-list__item');

    if (!container.classList.contains('is-preview')) {
      return;
    }

    const video = container.querySelector('video');
    if (!video) {
      return;
    }

    video.src = container.getAttribute('data-src');
    video.play();

    container.classList.remove('is-preview');
  }

  mobilePlayControlClickHandler(e) {
    const target = e.target.closest('.preview');
    if (!target) {
      return;
    }

    const container = target.closest('.video-inline-list__media');

    const previewContainer = container.querySelector('.preview');
    if (previewContainer) {
      previewContainer.remove();
    }

    const video = container.querySelector('video');
    if (!video) {
      return;
    }

    video.src = container.getAttribute('data-src');
    video.play();

    container.classList.remove('is-preview');
  }

  activeIndexChangeHandler(swiper) {
    const actionList = this.container.querySelector('.action-list');
    const actionListItem = [...actionList.children][swiper.realIndex];
    switchActive(actionListItem);

    this.pausePrevVideo(swiper);
  }

  mobileActiveIndexChangeHandler(swiper) {
    this.mobilePausePrevVideo(swiper);
  }

  pausePrevVideo(swiper) {
    const videoItems = [...swiper.el.querySelectorAll('.video-list__item')];
    const prevVideo = videoItems[swiper.previousIndex].querySelector('video');
    if (prevVideo) {
      prevVideo.pause();
    }
  }

  mobilePausePrevVideo(swiper) {
    const videoItems = [...swiper.el.querySelectorAll('.video-inline-list__item')];
    const prevVideo = videoItems[swiper.previousIndex].querySelector('video');
    if (prevVideo) {
      prevVideo.pause();
    }
  }
}